import React from 'react';
import ExpenseProposalWorkspace from './ExpenseProposalWorkspace';

/** 지출품의승인 */
export default function ExpenseProposalApprove() {
  return <ExpenseProposalWorkspace screenMode="approve" />;
}
